import { render, staticRenderFns } from "./EmpresaCnpjInput.vue?vue&type=template&id=90f4b49c&"
import script from "./EmpresaCnpjInput.vue?vue&type=script&lang=js&"
export * from "./EmpresaCnpjInput.vue?vue&type=script&lang=js&"
import style0 from "./EmpresaCnpjInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports